import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  ReplenishmentTaskV3ActivityType,
  ReplenishmentTaskV3ItemType,
  ReplenishmentTaskV3Type,
} from 'features/SupplyOrder/@types/ReplenishmentV3'
import {
  SLICE_NAME,
  fetchGetReplenishmentLetdownTaskDetail,
  fetchGetReplenishmentLetdownTaskItems,
} from './thunk'

export type ReplenishmentTaskDetailSliceType = {
  isLoading: boolean
  header: Nullable<ReplenishmentTaskV3Type>
  detailList: {
    data: ReplenishmentTaskV3ItemType[]
  }
  activityList: ReplenishmentTaskV3ActivityType[]
  pageType: 'LETDOWN' | 'PUTAWAY'
}

const initialState: ReplenishmentTaskDetailSliceType = {
  isLoading: false,
  header: null,
  detailList: {
    data: [],
  },
  activityList: [],
  pageType: 'LETDOWN',
}

const replenishmentTaskDetailSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetReplenishmentTaskDetail: () => initialState,
    setPageType: (state, action: { payload: 'LETDOWN' | 'PUTAWAY' }) => {
      state.pageType = action.payload
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<ReplenishmentTaskDetailSliceType>) => {
      builder
        .addCase(fetchGetReplenishmentLetdownTaskDetail.fulfilled, (state, action) => {
          state.header = action.payload.replenishment_task
          state.activityList = action.payload.replenishment_task_activities
        })
        .addCase(fetchGetReplenishmentLetdownTaskItems.fulfilled, (state, action) => {
          state.detailList.data = action.payload.data
        })
    },
    [],
  ),
})

export const { resetReplenishmentTaskDetail, setPageType } = replenishmentTaskDetailSlice.actions
export default replenishmentTaskDetailSlice.reducer
